import { createIcon } from '../createIcon';
import { ReactComponent as IconRulerVertical } from '../svg/ruler-vertical.svg';

export default createIcon(IconRulerVertical);
